import { useMemo } from 'react';
import DocumentTitle from 'react-document-title';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import SessionInfoContext from 'hb-react/frontoffice/contexts/SessionInfoContext';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import MembershipsIndex from 'hb-react/shared/apps/Memberships/containers/MembershipsIndex';
import ErrorBoundary from 'hb-react/shared/components/ErrorBoundary';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';

const MembershipsV2AppStandalone = ({
  membershipsSessionInfo,
  network,
  page_title: pageTitle,
}) => {
  const providerValue = useMemo(
    () => ({ memberships: membershipsSessionInfo }),
    [membershipsSessionInfo],
  );

  return (
    <ErrorBoundary
      context={{
        tags: {
          module: 'memberships_v2',
        },
      }}
    >
      <PublicOfficeApp network={network}>
        <BrowserRouter>
          <Routes>
            <Route
              path={'/memberships/*'}
              element={
                <SessionInfoContext.Provider value={providerValue}>
                  <DocumentTitle
                    title={generatePageTitle({
                      title: pageTitle,
                      networkName: network.page_title || network.title,
                    })}
                  />
                  <MembershipsIndex
                    appPageConfig={network.network_config?.custom?.page}
                  />
                </SessionInfoContext.Provider>
              }
            />
          </Routes>
        </BrowserRouter>
      </PublicOfficeApp>
    </ErrorBoundary>
  );
};

export default MembershipsV2AppStandalone;
